import React, { useState, useEffect, useRef, useCallback, memo } from 'react';
import { useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';

import Header from '../../common/Header/Header';
import { headerImg } from '../../config';
import { GenericDiv, InnerWrapper, FlexDiv } from 'commonStyles';
import MetaTags from 'common/metaTags';
import ContentSection from './components/ContentSection/ContentSection';
import { INTEGRATION_AWARNESS_CONSTANTS } from 'AppConstants';
import { fetchIntegrationData } from 'reduxStore/actions/integrationActionDispatcher';
import { getDetailConfigKey, logOmniture } from 'UtilityComponents/intergarationUtils';
import ApiError from 'common/ApiError/ApiError';

const IntegrationDetail = () => {
	const dispatch = useDispatch();
	const scrollRef = useRef();
	const { pathname } = useLocation();
	const [activeSection, setActiveSection] = useState('');

	const integrationData = useSelector((state) => state.integrationAwarness.integrationDetailData || {});
	const error = useSelector((state) => state.integrationAwarness.integrationDetailData.error || false);
	const { leftSection = {}, meta = {} } = integrationData;
	const { nav } = leftSection;
	const { pageLoadEvent = {}, mailerDetails, crumbData = [] } = meta;
	const { trackEvent, pageName } = pageLoadEvent;

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		() => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [scrollRef, handleScroll]);

	useEffect(() => {
		const key = getDetailConfigKey(pathname);
		if (error || !integrationData.meta) {
			dispatch(fetchIntegrationData(key, INTEGRATION_AWARNESS_CONSTANTS.DETAIL_REDUX_KEY));
		}
	}, [pathname, dispatch]);

	useEffect(() => {
		logOmniture(trackEvent, pathname, pageName);
	}, [trackEvent, pageName, pathname]);

	useEffect(() => {
		setActiveSection(nav?.[0]?.key || '');
	}, [nav]);

	const handleScroll = useCallback(() => {
		const tabs = document.querySelectorAll('.intTab__item') || [];
		const length = tabs?.length;
		for (let i = 0; i < length; i++) {
			const id = tabs[i].id;
			const linkto = id.substring(3);
			const linkToElem = document.getElementById(linkto);
			handler(linkToElem, linkto);
		}
	}, []);

	const handler = (linkToElem, linkto) => {
		const scrollPos = window.pageYOffset;
		if (linkToElem) {
			const topoffset = linkToElem.offsetTop - 50;
			const bottomoffset = topoffset + linkToElem.offsetHeight;
			if (topoffset <= scrollPos && bottomoffset >= scrollPos) {
				setActiveSection(linkto);
			}
		}
	};

	const updateActiveSection = (index, key) => () => {
		handleNavBar(key);
	};

	const handleNavBar = (key) => {
		const linkToElem = document.getElementById(key);
		const yOffset = -120;
		const y = linkToElem.getBoundingClientRect().top + window.pageYOffset + yOffset;
		window.scrollTo({
			top: y,
			behavior: 'smooth'
		});
	};

	if (error) {
		return (
			<FlexDiv height='100vh'>
				<ApiError
					$bg='#fbfbfb'
					textSize='14'
					imgMargin='25px'
					headSize='20px'
					bottom_P='63'
					top_P='40'
					imgWidth='100px'
					imgHeight='100px'
					$direction='column'
					justify='center'
					align='center'
					txtAlign='center'
				/>
			</FlexDiv>
		);
	}

	return (
		<GenericDiv top_P='16' bottom_P='16'>
			<MetaTags titleTxt={meta.title} description={meta.description} />
			<InnerWrapper bgColor='#fff' height='100%' paddingHr='94px 0 0'>
				<div style={{ position: 'relative' }}>
					<Header showBreadCrumbs headerImg={headerImg.detail} mailerDetails={mailerDetails} headerBg='#FFF' crumbData={crumbData} />
					<ContentSection scrollRef={scrollRef} activeSection={activeSection} contentData={integrationData} updateActiveSection={updateActiveSection} />
				</div>
			</InnerWrapper>
		</GenericDiv>
	);
};

export default memo(IntegrationDetail);
